import React from "react";
import { Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { useAppApi } from "@/App";
import { DefaultLayout } from "@components/Layouts";
import { ListingCard } from "@components/Pages";
import { url_reverse } from "@components/Utils";

export default function MerchantSetScreen() {
    const { t } = useTranslation();
    const header = t("Наборы мерчантов");
    return (
        <DefaultLayout>
            <MerchantSetList header={header} />
        </DefaultLayout>
    );
}

function MerchantSetList({ header }) {
    const { t } = useTranslation();
    const { apiData } = useAppApi(url_reverse("api:market:merchant_set:list"));

    if (!apiData) return;

    return (
        <ListingCard header={header}>
            <Table hover responsive className="dmg-table">
                <thead>
                    <tr>
                        <th>{t("Название")}</th>
                        <th>{t("Количество игр")}</th>
                        <th>MARKET</th>
                        <th>PARTNER</th>
                    </tr>
                </thead>
                <tbody>
                    {apiData.object_list?.map((o, i) => {
                        return (
                            <tr key={`object_list${i}`}>
                                <td>
                                    <a
                                        href={url_reverse("games:list", null, { "filter-merchant_set_id": o.id })}
                                        target="_blank"
                                    >
                                        {o.name}
                                    </a>
                                </td>
                                <td>{o.__games_cnt || ""}</td>
                                <td>{o.mr_merchant.merchant_id || "-"}</td>
                                <td>{o.pr_merchant.merchant_id || "-"}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
        </ListingCard>
    );
}
